export const X_AXIS_LABEL = "X:";
export const X_AXIS_TOOLTIP = "Horizontial Offset";
export const Y_AXIS_LABEL = "Y:";
export const Y_AXIS_TOOLTIP = "Vertical Offset";
export const BLUR_LABEL = "B:";
export const BLUR_TOOLTIP = "Blur Radius";
export const SPREAD_LABEL = "S:";
export const SPREAD_TOOLTIP = "Spread Radius";
export const VALUE_INFORMATION = "💡 Each value is in px.";
